import { verifyIsOwner } from "@/components/authentication/utils";
import { useEffect, useState } from "react";

export const useIsOwner = () => {
  const [isOwner, setIsOwner] = useState<boolean>(false);

  useEffect(() => {
    (async () => {
      const result = await verifyIsOwner();
      setIsOwner(result);
    })();
  }, []);

  return isOwner;
};
